// extracted by mini-css-extract-plugin
export var addressFields = "_hz-0";
export var animationContainer = "_hz-1";
export var footer = "_hz-2";
export var lineItems = "_hz-3";
export var modalContent = "_hz-4";
export var orderName = "_hz-5";
export var strong = "_hz-6";
export var warning = "_hz-7";